import React from 'react';

import PropTypes from 'prop-types';

import ConfirmationModal from '../ConfirmationModal';
import ConfirmationModalInfo from '../ConfirmationModalInfo';

const DeactivateModal = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <ConfirmationModal
      title="config_manager.config_streaming.deactivate_drm_modal.title"
      subtitle="config_manager.config_streaming.deactivate_drm_modal.description"
      confirmLabel="config_manager.config_streaming.deactivate_drm_modal.confirm"
      isOpen={isOpen}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <ConfirmationModalInfo
        icon="shield"
        label="config_manager.config_streaming.deactivate_drm_modal.antifraud"
      />
      <ConfirmationModalInfo
        icon="download"
        label="config_manager.config_streaming.deactivate_drm_modal.download_not_protected"
      />
    </ConfirmationModal>
  );
};

DeactivateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default DeactivateModal;
